/* src/app/shared-components/export-modal/export-modal.component.scss */
.modal-title {
  margin-bottom: 1rem;
}
.select-all-btn {
  text-align: left;
  width: 100%;
  padding: 0.625rem 2.5rem 0.625rem 1rem;
  border-radius: 0;
}
.select-all-btn:hover {
  background-color: rgba(114, 114, 127, 0.08);
}
.extra-info-container {
  margin-top: 2.25rem;
}
.extra-info-container .tab-description {
  margin-bottom: 1rem;
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: #72727f;
}
.tabs-wrapper {
  width: 100%;
  padding-top: 0.9375rem;
  overflow-x: auto;
  border-bottom: 1px solid rgba(46, 46, 56, 0.08);
  margin-bottom: 1rem;
  flex-wrap: nowrap;
}
.tabs-wrapper .tabs-container {
  margin-right: 1.5625rem;
}
.tabs-wrapper .tabs-container .single-tab {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: rgba(46, 46, 56, 0.64);
  margin-right: 1.5rem;
  border-radius: 0;
  border: 0;
  padding: 0;
  border-bottom: 0.25rem solid transparent;
  padding-bottom: 0.25rem;
  white-space: nowrap;
}
.tabs-wrapper .tabs-container .single-tab.active {
  color: #2e2e38;
  text-shadow: 0 0 0.1px #2e2e38, 0 0 0.1px #2e2e38;
}
.tabs-wrapper .tabs-container .single-tab:last-child {
  margin-right: 0;
}
.tabs-wrapper .tabs-container .single-tab.btn:focus {
  box-shadow: none;
}
.isin-container {
  display: flex;
  align-items: center;
  background-color: rgba(114, 114, 127, 0.08);
  border: 0.0625rem solid rgba(46, 46, 56, 0.08);
  overflow: auto;
}
.isin-container .form-control {
  border: 0;
  background-color: transparent;
}
.isin-container .selected {
  white-space: nowrap;
}
/*# sourceMappingURL=export-modal.component.css.map */
